import React from "react";
import LocalBarIcon from "@mui/icons-material/LocalBar";
import { EyeSlashIcon } from "@heroicons/react/24/outline";
import { normalizeBreaks } from "../utils/useWeeklyShiftEditor";


export function buildBreaksPreview(breaks) {
  const br = normalizeBreaks(breaks);

  return (
    <div className="mt-0.5 flex flex-wrap items-center gap-1.5">
      <span className="inline-flex items-center gap-1 rounded-full bg-indigo-50 px-2 py-0.5 text-[11px] font-semibold text-indigo-700 border border-indigo-100">
        <LocalBarIcon style={{ height: 12, width: 12, color: "#4f46e5" }} />
        Pause
      </span>

      {br.length > 0 ? (
        br.map((b, j) => {
          const hidden = b?.is_visible === false;
          const key = b?.id ?? `${j}-${b.start_at}-${b.end_at}`;

          return (
            <span
              key={key}
              className={`inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[11px] font-semibold border ${
                hidden ? "bg-gray-100 text-gray-500 border-gray-200" : "bg-white text-gray-700 border-gray-200"
              }`}
              title={hidden ? "Pausa nascosta" : "Pausa visibile"}
            >
              {hidden && <EyeSlashIcon className="h-3.5 w-3.5 text-gray-500" />}
              {b.start_at} - {b.end_at}
            </span>
          );
        })
      ) : (
        <span className="text-[11px] text-gray-400 ml-1">Nessuna</span>
      )}
    </div>
  );
}